const BASE_DOMAIN = Object.freeze({
  PRODUCTION: 'squareup.com',
  STAGING: 'squareupstaging.com',
});

/**
 * The raw environment metadata from the sq:environment meta tag, or null
 * when the tag is absent (e.g. crawler-rendered pages). Callers that use
 * the null return as a signal to skip side effects entirely (tracking,
 * error reporting) should keep using this; callers that just need the
 * environment name should use getEnv().
 */
const getEnvironment = () => {
  const envMeta = document.querySelector("meta[name='sq:environment']");
  if (!envMeta) {
    return null;
  }

  return JSON.parse(envMeta.getAttribute('content'));
};

/**
 * The environment name, defaulting to production when the sq:environment
 * meta tag is absent (e.g. crawler-rendered pages) so callers fail safe
 * instead of crashing or falling open to dev/staging behavior.
 */
const getEnv = () => getEnvironment()?.env ?? 'production';

// The sq:environment meta tag can be absent on crawler-rendered pages
// (e.g. Google Storebot). Assume production in that case rather than
// crashing with "Cannot read properties of null (reading 'env')".
const getDomain = (otherSubdomain) => {
  const { env = 'production', app_subdomain = 'app.' } = getEnvironment() || {};
  const host =
    env === 'production' ? BASE_DOMAIN.PRODUCTION : BASE_DOMAIN.STAGING;

  // other subdomains do not need the 'app' subdomain too
  const subdomain =
    otherSubdomain || otherSubdomain === '' ? otherSubdomain : app_subdomain;

  return `${subdomain}${host}`;
};

const getHost = () => {
  return getEnv() === 'production'
    ? 'https://api.squareup.com'
    : 'https://api.squareupstaging.com';
};

export { BASE_DOMAIN, getEnvironment, getEnv, getDomain, getHost };
